import { render, staticRenderFns } from "./StudioEventSelectProduct.vue?vue&type=template&id=2b75e61a&scoped=true&"
import script from "./StudioEventSelectProduct.vue?vue&type=script&lang=js&"
export * from "./StudioEventSelectProduct.vue?vue&type=script&lang=js&"
import style0 from "./StudioEventSelectProduct.vue?vue&type=style&index=0&id=2b75e61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b75e61a",
  null
  
)

export default component.exports